var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ITEXTFIELD_PROP_NAMES = {
  text: "#text"
};
const ICDATASECTION_PROP_NAMES = {
  cdata_section: "#cdata-section"
};
const IEXTENSION_PROP_NAMES = {
  foray_isForaySegment: "foray:IsForaySegment"
};
const ICOMPUTATION_PROP_NAMES = {
  name: "@Name",
  c: "@c",
  type: "@Type",
  extension: "Extension"
};
const IMETRIC_PROP_NAMES = __spreadProps(__spreadValues({}, ICOMPUTATION_PROP_NAMES), {
  levels: "@Levels",
  colorScheme: "@ColorScheme",
  foray_definition: "foray:Definition",
  foray_description: "foray:Description",
  foray_displayName: "foray:DisplayName"
});
const ICOLUMN_PROP_NAMES = __spreadProps(__spreadValues({}, ICOMPUTATION_PROP_NAMES), {
  type: "@Type",
  isPublic: "@IsPublic",
  level: "@Level"
});
export {
  ICDATASECTION_PROP_NAMES,
  ICOLUMN_PROP_NAMES,
  ICOMPUTATION_PROP_NAMES,
  IEXTENSION_PROP_NAMES,
  IMETRIC_PROP_NAMES,
  ITEXTFIELD_PROP_NAMES
};
//# sourceMappingURL=MDLComputations.constants.js.map
